<template>
  <div class="label">
    <!-- <div @click="toLoginFun()">
      <div>登录</div>
    </div> -->
    <div
      v-on:mouseover="showToggle(true)"
      v-on:mouseout="showToggle(false)"
      :class="[NavBar == 1 ? 'NarBarUlColor1' : 'NarBarUlColor2']"
    >
      <div
        class="login_txt"
        :class="[NavBar == 1 ? 'NarBarColor1' : 'NarBarColor2']"
      >
        <div v-if="loginName" class="user_login">
          <div :class="[language == 'zh' ? 'zhFamily' : 'enfamily']">
            {{ loginName }}
          </div>
          <div class="user_login_i">
            <i class="iconfont icon-xiangxia1"></i>
          </div>
        </div>

        <div v-else @click="toLogin()">
          <!-- <div v-else @click="toLoginFun()"> -->
          <div :class="[language == 'zh' ? 'zhFamily' : 'enfamily']">
            {{ $t("Nav.User.Login") }}
          </div>
        </div>
      </div>
      <!-- index === isShow -->
      <div v-show="userList && loginName">
        <div class="hoverShow">
          <div
            @click="logout()"
            :class="[language == 'zh' ? 'zhFamily' : 'enfamily']"
          >
            {{ $t("Nav.User.Logout") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/bus";
import { mapMixin } from "@/util/mixin";
import { logout, cloudLogin, dealCode } from "@/axios/user.js";
export default {
  mixins: [mapMixin],
  props: ["NavBar"],
  mounted() {
    bus.$on("ThirdUserLogin", () => {
      this.toLoginFun();
    });
  },
  data() {
    return {
      Menu: [],
      userList: false,
    };
  },

  methods: {
    async logout() {
      var loginName = window.localStorage.getItem("loginName");
      var res = await logout(loginName);
      if (res.data.code == 200) {
        localStorage.setItem("loginName", "");
        localStorage.setItem("token", "");
        localStorage.setItem("id_token", "");
        localStorage.setItem("token_type", "");
        this.setLoginName("");
      }
    },
    // 获取地址栏参数
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    toLoginFun() {
      this.cloudLoginFun();
    },
    // 获取返回地址
    async cloudLoginFun() {
      var res = await cloudLogin();
      console.log(res.data.data, this.$route.query);
      // return
      window.location.href = res.data.data; //外链地址
      console.log(this.$route.query.code);
    },
    // 处理code
    async dealCodeFun() {
      var res = await dealCode();
      console.log(res);
    },
    toLogin() {
      this.$router.push("/login");
    },

    showToggle(boole) {
      this.userList = boole;
    },
  },
  created() {},
};
</script>
  <style scoped lang="scss">
.zhFamily {
  font-family: $zhFamily;
}
.enfamily {
  font-family: $enFamily;
}
.label {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.active {
  //   color: #000;
  /* background-color: rgba(0, 0, 0, 0.3); */
  background-size: 50% 4px !important;
}

.login_txt {
  // color: #fff;
  background-image: linear-gradient(#fff, #fff);
  background-position: center bottom;
  background-repeat: no-repeat;
  transition: background-size 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
  text-decoration: none;
  height: 20px;
  background-size: 0 4px;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  font-size: 12px;

  .user_login {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .user_login_i {
    transition: 0.2s;
    transform: rotate(0);
    margin-left: 8px;
    i {
      color: #ccc;
      font-size: 14px;
    }
  }
}
.NarBarColor1 {
  color: #ccc;
}
.NarBarColor2 {
  color: #000;
}
.sort:last-child {
  width: 130px;
}
.sort:nth-child(3) {
  width: 120px;
}

.hoverShow {
  z-index: 999;
  cursor: pointer;
  //   width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 3px;
}
.hoverShow div {
  text-align: center;
  width: 100%;
  height: 60px;
  line-height: 60px;
  padding: 0 6px;
  box-sizing: border-box;
  font-size: 14px;
}
// .hoverShow div:hover {
//   background: rgba(0, 0, 0, 0.6);
// }
.NarBarUlColor1 {
  .title {
    color: #fff;
    background-image: linear-gradient(#fff, #fff);
  }
  .activeLanguage {
    color: #fff !important;
  }
  .hoverShow div {
    color: #fff;
    background: rgba(0, 0, 0, 0.3);

    &:hover {
      background: rgba(0, 0, 0, 0.6);
      //   opacity: .8;
    }
  }
}
.NarBarUlColor2 {
  .title {
    color: #000;
    background-image: linear-gradient(#0052d9, #0052d9);
  }
  .activeLanguage {
    color: #066cac !important;
  }
  .hoverShow div {
    color: #000;
    background: rgba(255, 255, 255, 1);

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>

